/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
// component
import Statistics from 'pages/dashboard/commenting/statistics/statistics';
// action
import { loadCommentingStatisticsTableData, exportStatisticsData } from 'state/actions/commentingState/statisticsStatus';



/* ========== ~~~~~~~~~~ COMMENTING STATISTICS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ commentingState, sessionStatus }) => ({
    accountUUID: sessionStatus.accountUUID,
    commentingUnitUUID: commentingState.configStatus.commentingUnitUUID,
    statistics: commentingState.statisticsStatus.commentingStatistics,
    fetchingCommentingStatistics: commentingState.statisticsStatus.fetchingCommentingStatistics,
    hasMoreData: commentingState.statisticsStatus.hasMoreData
});

// map actions
const mapDispatchToProps = dispatch => ({
    loadCommentingStatisticsTableData: (commentingUnitUUID, interval, skip, existingData) => dispatch(loadCommentingStatisticsTableData(commentingUnitUUID, interval, skip, existingData)),
    exportStatisticsData: (commentingUnitUUID, interval) => dispatch(exportStatisticsData(commentingUnitUUID, interval))
});

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Statistics));
